import Component from '../abstracts/Component';
import {IS_PRIVACY_PAGE} from '../utils/Environment';
import FidelityPopupComponent from './FidelityPopupComponent';
import ModalMixinComponent from './mixins/ModalMixinComponent';

import Cookies from 'js-cookie';
export default class NewsletterPopupComponent extends Component {
  get SELECTORS() {
    return {
      communicationPopup: '[data-js-component="CommunicationPopupComponent"]',
      fidelityPopup: '[data-js-component="FidelityPopupComponent"]',
    }
  }

  constructor(elem) {
    super(elem);
    this.modal = new ModalMixinComponent(elem);

    this.setCookie = this.setCookie.bind(this);
    this.getCookie = this.getCookie.bind(this);
    this.isCommunicationPopupShown = this.isCommunicationPopupShown.bind(this);
  }

  render() {
    this.modal.render();
    this.bindEvents();
    const fidelityPopup = new FidelityPopupComponent();

    if (this.getCookie() && !this.isCommunicationPopupShown() && (!fidelityPopup.isShown() || fidelityPopup.getCookie())) {
      setTimeout(() => {
        this.modal.show();
      }, 22000);
    }
  }

  bindEvents() {
    this.$component.addEventListener(this.$customEvents.MODAL.hide, () => {
      this.setCookie();
    });

    this.$component.addEventListener(this.$customEvents.NEWSLETTER.subscribed, () => {
      this.setCookie();
    });

    this.$on(this.$customEvents.COM_POPUP.hide, () => {
      if(this.getCookie()){
        this.modal.show();
      }
    });
    this.$on(this.$customEvents.FIDELITY_POPUP.hide, () => {
      if(this.getCookie() && !this.isCommunicationPopupShown()){
        this.modal.show();
      }
    });
  }

  get COOKIE_NAME() {
    const modalkey = document.body.dataset.nlKey || 'default_modal';
    return 'nl_' + modalkey + '_hide';
  }

  setCookie() {
    Cookies.set(this.COOKIE_NAME, 'true', {
      expires: 365,
      path: '/'
    });
  }

  getCookie() {
    return !Cookies.get(this.COOKIE_NAME) && !IS_PRIVACY_PAGE;
  }

  isCommunicationPopupShown() {
    const popup = document.querySelector(this.SELECTORS.communicationPopup);
    return (popup != null) ? popup.component.isShown() : false ;
  }
}
